export default __webpack_public_path__ + "static/16-f420fbd13549c65bcb75e7e95a38f6b7.webp";